  <div>
    <p-table styleClass="mt-4" #grid [value]="templateVariables" 
    [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
      [paginator]="true" [rows]="25" [totalRecords]="totalRecords" 
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
      [rowsPerPageOptions]="[25,100,250]" 
      [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
      <ng-template pTemplate="header" let-columns>
          <tr>
              <th pSortableColumn="key">Nombre </th>
              <th >Nombre </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template let-columns="columns">
          <tr>
              <td>{{template.key}}</td>
              <td>
                {{template.value}}
              </td>
          </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="mt-4 flex gap-2 justify-content-end">     
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
  </div>

